import { links, getBrandLink } from 'common/helpers'


type GetSeoProductsLinkInput = {
  brand?: string
  isMale: boolean
  url: string
}

const getSeoProductsLink = ({ brand = '', isMale, url }: GetSeoProductsLinkInput): string => {
  if (/cream/.test(url)) {
    return links.fromBackend.personalCareHandCream
  }
  if (/body-lip/.test(url)) {
    return links.fromBackend.skincareLip
  }
  if (/candles/.test(url)) {
    return links.candles
  }
  if (/palette/.test(url)) {
    return links.fromBackend.makeupPalette
  }
  if (/eyeliner/.test(url)) {
    return links.fromBackend.makeupEye
  }
  if (/lip/.test(url)) {
    return links.fromBackend.makeupLip
  }
  if (/extras/.test(url)) {
    return links.subscription.extras
  }

  return getBrandLink({ brand, isMale })
}


export default getSeoProductsLink
